module.exports = __webpack_public_path__ + "img/pc_2.b8f8f43c.png";